import type { Rule } from 'antd/es/form';

import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';

import { MAX_ROOM_DISCOUNT_PERCENT } from '../../../../utils/rooms';

import type { DefaultDiscountMode } from './hooks/useRoomDiscountLogic';

export const ROOM_DISCOUNT_OVER_MAX_MESSAGE = 'Discount is too high';

export const maxRoomDiscountRule: Rule = {
  type: 'number',
  max: MAX_ROOM_DISCOUNT_PERCENT,
  message: ROOM_DISCOUNT_OVER_MAX_MESSAGE,
};

export const isRoomDiscountOverMax = (discount?: number | null) =>
  discount !== null &&
  discount !== undefined &&
  discount > MAX_ROOM_DISCOUNT_PERCENT;

export const hasRoomDiscountOverMax = ({
  defaultDiscountMode,
  defaultNightRoomDiscount,
  defaultNightRoomDiscountDays,
  lastMinuteNightRoomDiscountRate,
}: {
  defaultDiscountMode?: DefaultDiscountMode;
  defaultNightRoomDiscount?: number | null;
  defaultNightRoomDiscountDays?: Partial<Record<DayOfWeek, number>> | null;
  lastMinuteNightRoomDiscountRate?: number | null;
}) =>
  (defaultDiscountMode === 'DAILY'
    ? Object.values(defaultNightRoomDiscountDays ?? {}).some(
        isRoomDiscountOverMax
      )
    : isRoomDiscountOverMax(defaultNightRoomDiscount)) ||
  isRoomDiscountOverMax(lastMinuteNightRoomDiscountRate);
